function shallowCopy(source, dest, ignoreEmpty) {
    if (ignoreEmpty === void 0) { ignoreEmpty = false; }
    for (var k in source) {
        if (Object.prototype.hasOwnProperty.call(source, k)) {
            var val = source[k];
            if (!ignoreEmpty) {
                dest[k] = val;
            }
            else {
                if (val !== '' && val !== undefined && val !== null) {
                    dest[k] = val;
                }
            }
        }
    }
}
function nextTick(fn) {
    if (typeof Promise === 'function' && typeof Promise.resolve === 'function') {
        Promise.resolve().then(fn);
    }
    else {
        setTimeout(fn);
    }
}
function throttleOrDebounce(type, fn, interval, ctx) {
    var isThrottle = type === 'throttle';
    var fnName = (isThrottle ? 'throttle' : 'debounce') + "_" + (fn.name || 'anonymous');
    try {
        return Function('fn', 'ctx', "\n      var canCall = true;\n      var callTimer;\n      var lastCallTimer;\n\n      return function " + fnName + "() {\n        if (lastCallTimer) {\n          clearTimeout(lastCallTimer);\n          lastCallTimer = null;\n        }\n\n        if (canCall) {\n          canCall = false;\n          try {\n            fn.apply(ctx, arguments);\n          } finally {\n            if (" + isThrottle + ") {\n              callTimer = setTimeout(() => {\n                callTimer = null;\n                canCall = true;\n              }, " + interval + ");\n            }\n          }\n        } else {\n          var args = arguments;\n          lastCallTimer = setTimeout(function lastCall_" + fnName + "() {\n            lastCallTimer = null;\n            fn.apply(ctx, args);\n          }, " + interval + ");\n        }\n\n        if (" + !isThrottle + ") {\n          if (callTimer) {\n            clearTimeout(callTimer);\n          }\n\n          callTimer = setTimeout(() => {\n            callTimer = null;\n            canCall = true;\n          }, " + interval + ");\n        }\n      }\n    ")(fn, ctx);
    }
    catch (e) {
        console.info('throttleOrDebounce error', e);
        return fn;
    }
}
var storage = {
    data: {},
    get: function (key) {
        if (key in this.data) {
            return this.data[key];
        }
        if (window && localStorage) {
            var t = localStorage.getItem(key) || '';
            if (t) {
                return (this.data[key] = t);
            }
        }
        return '';
    },
    set: function (key, value) {
        this.data[key] = value;
        if (window && localStorage) {
            try {
                localStorage.setItem(key, value);
            }
            catch (e) {
            }
        }
    },
};
function generateFrom(length, sourceStr) {
    if (length === void 0) { length = 32; }
    sourceStr = sourceStr || 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var totalLen = sourceStr.length;
    var ret = '';
    for (var i = 0; i < length; i++) {
        ret += sourceStr.charAt(~~(Math.random() * totalLen));
    }
    return ret;
}
function generateWebID() {
    var k1 = generateFrom(8);
    var k2 = Date.now().toString(36).slice(0, 8);
    var k3 = generateFrom(8);
    var k4 = (parseInt(k1, 36) + parseInt(k2, 36) + parseInt(k3, 36)).toString(36).slice(0, 8);
    var t = '';
    for (var i = 0; i < 8; i++) {
        t += k1[i] + k2[i] + k3[i];
    }
    return "" + t + k4;
}
function generate18ID() {
    var k1 = generateFrom(1, '123456789') + generateFrom(2, '0123456789');
    var k2 = Date.now();
    var t = ((Number(k1) * k2) % 100) + '';
    t = t.length < 2 ? "0" + t : t;
    return "" + k1 + k2 + t;
}
var WebID_Key = '__clue_web_id_921e691f871caa6e729d47babff8ead6__';
function getWebID() {
    var id = storage.get(WebID_Key);
    if (!id) {
        id = generateWebID();
        storage.set(WebID_Key, id);
    }
    return id;
}
var getSessionID = (function (sessionId) {
    return function getSessionID() {
        return sessionId;
    };
})(generate18ID());
var generateCommitID = generate18ID;
function getPageIdFormUrl(url) {
    var m = url.match(/\/tetris\/(?:page|ultra|store|exp\/orange)\/(?:creative\/)?(\d+)\b/);
    return m && m.length > 1 ? m[1] : '';
}
function maskPhoneNo(phoneNo) {
    return phoneNo.replace(/(\d{3})(\*{4})(\d{2})(\d{2})/, '$1******$4');
}
export { shallowCopy, nextTick, throttleOrDebounce, maskPhoneNo, getWebID, getSessionID, generateCommitID, generateFrom, getPageIdFormUrl, };
